module.exports = __webpack_public_path__ + "img/icon-customers.6dec502c.svg";